<!--
 * @Author       : NN
 * @Date         : 2020-08-12
 * @Description  : 添加门店
 -->
<template>
	<div class="goods-add" :style="goodsstyle">
		<a-card :bordered="false">
			<a-card title="添加办事处地址" :bordered="false">
			<div style="margin-left: 31px">注：可不填</div>
				<a-form class="boxs" :form="form">
					<a-form-item label="公司名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-input placeholder="请输入公司名称" v-decorator="['name', { rules: [{ required: true,message: '请输入门店名称'}] }]" style="width: 346px;"></a-input>
					</a-form-item>
					
					<a-form-item label="联系电话" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-input @input="changeTel" placeholder="请输入联系电话" v-decorator="['mobile', { rules: [{ required: true,message: '请输入联系电话'}] }]" style="width: 346px;"></a-input>
					</a-form-item>
					
					<a-form-item label="上班时间" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-input type="hidden" v-decorator="['must', { rules: [{ required: true,message: '请输入时间'}],initialValue: 1 }]"></a-input>
						
						<a-form-item style="width: 162px;display: inline-block">
							<a-time-picker placeholder="请输入开始时间" :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm" v-decorator="['start_time', { rules: [{ required: true,message: '请输入开始时间'}] }]" style="width: 162px"/>
						</a-form-item>
						
						至
						
						<a-form-item style="width: 162px;display: inline-block">
							<a-time-picker placeholder="请输入结束时间" :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm" v-decorator="['end_time', { rules: [{ required: true,message: '请输入结束时间'}] }]" style="width: 162px"/>
						</a-form-item>
					</a-form-item>
					
					<a-form-item label="选择地区" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-input type="hidden" v-decorator="['must1', { rules: [{ required: true,message: '请输入时间'}],initialValue: 1 }]"></a-input>
						
						<a-form-item style="width: 110px;display: inline-block;margin-right: 8px;">
							<a-select placeholder="省" @change="changeSheng" data-level="1" v-decorator="['sheng', { rules: [{ required: true,message: '请选择省份'}] }]" style="width: 110px">
							      <a-select-option v-for="item,index of shenOptions" :key="item.GroupID" :value="item.GroupID">
							        {{item.G_CName}}
							      </a-select-option>
							</a-select>
						</a-form-item>
						<a-form-item style="width: 110px;display: inline-block;margin-right: 8px;">
							<a-select @change="changeShi" data-level="2" placeholder="市" v-decorator="['shi', { rules: [{ required: true,message: '请选择城市'}] }]" style="width: 110px">
							      <a-select-option v-for="item,index of shiOptions" :key="item.GroupID" :value="item.GroupID">
							        {{item.G_CName}}
							      </a-select-option>
							</a-select>
						</a-form-item>
						<a-form-item style="width: 110px;display: inline-block">
							<a-select placeholder="区" v-decorator="['xian', { rules: [{ required: true,message: '请选择区域'}] }]" style="width: 110px">
							      <a-select-option v-for="item,index of xianOptions" :key="item.GroupID" :value="item.GroupID">
							        {{item.G_CName}}
							      </a-select-option>
							</a-select>
						</a-form-item>
					</a-form-item>
					
					<a-form-item label="详细地址" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-input placeholder="请输入详细地址" v-decorator="['address', { rules: [{ required: true,message: '请输入详细地址'}] }]" style="width: 346px;"></a-input>
					</a-form-item>
					
				</a-form>
			</a-card>
			
			<div style="height: 40px;"></div>

			<div class="foot">
				<a-button type="danger" class="btns" @click="onGoBack">取消</a-button>
				<a-button type="primary" @click="onSave">保存</a-button>
			</div>
		</a-card>
	</div>
</template>

<script>
import moment from 'moment';
export default {
	data() {
		return {
			moment,
			form: this.$form.createForm(this, { name: 'form_in_modal' }),
			goodsstyle: {
				height: '600px'
			},
			
			shenOptions: [],
			shiOptions: [],
			xianOptions: [],
			areaLevel: 0
		};
	},
	mounted() {
		let content = document.querySelectorAll('.ant-layout-content')[0].offsetHeight;
		this.goodsstyle = {
			height: content + 'px'
		};
		
		this.getAddress();
	},
	methods: {
		changeTel(e){
			let val = e.target.value.replace(/\D/g,'')
			this.form.setFieldsValue({mobile: val})
		},
		changeSheng(id){
			this.areaLevel = 1
			
			this.getAddress(id)
		},
		changeShi(id){
			this.areaLevel = 2
			
			this.getAddress(id)
		},
		getAddress(GroupID){
			let data = {
				GroupID
			}
			
			this.$request.post('?module=pc_api&action=Mch&app=mch_address', data).then(res => {
				let { code, message, data } = res;
				if (code === 200) {
					if(this.areaLevel == 0){
						this.shenOptions = data
						this.shiOptions = []
						this.xianOptions = []
					}else if(this.areaLevel == 1){
						this.shiOptions = data
						this.xianOptions = []
						this.form.resetFields(['shi','xian'])
					}else{
						this.xianOptions = data
						this.form.resetFields(['xian'])
					}
				}
			});
		},
		/* 
			保存
		 */
		onSave(){
			this.form.validateFields((err, values) => {
			  if (!err) {
				let { start_time, end_time, sheng, shi, xian } = values
				
				values.business_hours = start_time.format("HH:mm")+'~'+end_time.format("HH:mm")
				
				this.shenOptions.some(item=>{
					if(item.GroupID == sheng){
						sheng = item.G_CName
					}
				})
				this.shiOptions.some(item=>{
					if(item.GroupID == shi){
						shi = item.G_CName
					}
				})
				this.xianOptions.some(item=>{
					if(item.GroupID == xian){
						xian = item.G_CName
					}
				})
				values.city_all = sheng+'-'+shi+'-'+xian
				
				let data = {...values}
				
				let url = '?module=pc_api&action=Mch&app=add_store';
				this.$request.post(url,data).then(res => {
					let { code, message, data } = res;
					if(code == 200){
						this.$message.success(message)
						
						setTimeout(()=>{
							this.$router.go(-1)
						},1000)
					}else{
						this.$message.error(message)
					}
				});
			  }
			})
		},
		/**
		* @name 返回
		* */ 
		onGoBack(){
		  this.$router.go(-1)
		},
	}
};
</script>

<style lang="less">
.modals {
	.ant-form-item {
		margin-bottom: 0px;
	}

	.boxs {
		display: flex;
		height: 36px;
		min-height: 36px;
		padding-top: 0px;
		align-items: center;
		width: 410px;
		justify-content: space-between;
	}
}
.goods-add {
	height: 100%;
	overflow-y: auto;
	.foot {
		height: 68px;
		width: 100%;
		border-top: 1px solid #e9ecef;
		position: sticky;
		bottom: 0;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 0px 60px;
		background: #ffffff;
		z-index: 999;

		.btns {
			margin-right: 10px;
		}
	}

	.ant-card-head {
		position: sticky !important;
		top: 0 !important;
		background: #ffff !important;
		z-index: 991 !important;
	}
}

.boxs {
	padding-top: 40px;
	min-height: 400px;
}

.clearfix {
	position: relative;
	width: 600px;
}
.setMap0,
.setMap1,
.setMap2,
.setMap3,
.setMap4 {
	position: absolute;
	bottom: 8px;
	height: 20px;
	font-size: 12px;
	line-height: 20px;
	text-align: center;
	width: 104px;
	background: rgba(0, 0, 0, 0.6);
	color: #ffffff;
	z-index: 99;
	cursor: pointer;
}
.setMap0 {
	left: 0;
	background: #2890ff;
	width: 32px;
}
.setMap1 {
	left: 112px;
}
.setMap2 {
	left: 224px;
}
.setMap3 {
	left: 336px;
}
.setMap4 {
	left: 448px;
}

.ant-card-body{
	padding: 0;
}
.ant-form-item{
	margin-bottom: 14px;
}

.jumpBox{
	display: flex;
	align-items: center;
	
	>div{
		flex: 1;
	}
}

.rangeBox{
	width:724px;
	padding: 14px;
	background:rgba(246,247,248,1);
	border-radius:2px;
	
	.ant-select-selection__rendered>ul .ant-select-selection__choice{
		display: none;
	}
	.ant-select-selection__placeholder{
		display: block!important;
	}
}
.rangeCheckBox{
	display: flex;
	margin-top: 14px;
	
	>span{
		line-height: 36px;
		margin-right: 10px;
	}
	
	>div{
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		overflow-y: auto;
		max-height: 250px;
	}
	
	.ant-tag{
		display: flex;
		align-items: center;
		height: 36px;
		min-height: 36px;
		padding: 0 10px;
		background-color: #FFFFFF;
		margin-bottom: 14px;
	}
}

</style>
